import { messages } from './messages';
import { dashboard } from './dashboard';
import { drafts } from './drafts';
import { manageShifts } from './manageShifts';
import { requestors } from './requestors';
import { myInfo } from './myInfo';
import { company } from './company';
import { forgotPassword } from './forgotPassword';
import { signIn } from './signIn';
import { termsOfService } from './termsOfService';
import { resetPassword } from './resetPassword';
import { positionListings } from './positionListings';
import { simplifiedJobPosting } from './simplifiedJobPosting';
import { jobPostingReview } from './jobPostingReview';
import { teams } from './teams';
import { moFlo } from './moFlo';
import { post } from './post';
import { locations } from './locations';
import { scheduleForm } from './scheduleForm';
import { positions } from './manage/positions';
import { schedules } from './schedules';
import { manageJobs } from './manageJobs';

export default {
  forgotPassword,
  messages,
  dashboard,
  manageShifts,
  drafts,
  requestors,
  myInfo,
  company,
  signIn,
  termsOfService,
  resetPassword,
  positionListings,
  simplifiedJobPosting,
  jobPostingReview,
  teams,
  moFlo,
  post,
  locations,
  schedule: {
    form: scheduleForm,
  },
  positions,
  schedules,
  manageJobs
};
